export const triggerFileDownload = (downloadURL) => {
    if (typeof downloadURL !== 'string' || downloadURL.trim() === '') {
        console.warn('Invalid download URL');
        return;
    }
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const downloadBase64File = (base64Data, filename = 'download.zip') => {
    try {
        // Convert base64 to blob
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading base64 file:', error);
        throw new Error('Failed to download file');
    }
};